import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SecAdminUserService } from "../../services/sec-admin-user.service";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styles: [],
    standalone: false
})
export class LogoutComponent implements OnInit {
  public errorMessage: string;

  constructor(private readonly titleService: Title, private readonly secAdminUserService: SecAdminUserService) { }

  ngOnInit(): void {
    this.titleService.setTitle("Sign Out");

    this.secAdminUserService.logout();
  }

}
